import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';

import 'bootstrap/dist/css/bootstrap.css';
import './index.scss';

ReactDOM.render(<App />, document.getElementById('root')
);

